export const generateRandomProjectName = (length: number = 6) => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  return `v-${Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('')}`;
};

export const generateRandomConnectionName = (length: number = 5) => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  return `c-${Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('')}`;
};
